import Dashboard from "../../views/dashboard/Dashboard.vue";

const createaccountmanagement = {
  path: "/createaccountmanagement",
  name: "createaccountmanagement",
  redirect: "createaccount",
  component: Dashboard,
  meta: {
    title: "用户管理",
    icon: "el-icon-user-solid",
    role: false
  },
  children: [
    {
      path: "/createaccount",
      name: "createaccount",
      component: () =>
        import("../../components/createaccountmanagement/createaccount.vue"),
      meta: {
        title: "创建用户",
        icon: "el-icon-plus",
        role: false
      }
    },
    {
      path: "/authoruitymanagement",
      name: "authoruitymanagement",
      component: () =>
        import(
          "../../components/createaccountmanagement/authoruitymanagement.vue"
        ),
      meta: {
        title: "权限管理",
        icon: "el-icon-tickets",
        role: false
      }
    },
    {
      path:"/paysetmanagement",
      name: "paysetmanagement",
      component: () =>
        import(
          "../../components/createaccountmanagement/paysetmanagement.vue"
        ),
      meta: {
        title: "支付参数",
        icon: "el-icon-video-camera-solid",
        role: false
      }
    }
  ]
};

export default createaccountmanagement;
